export const Auth_LOADING = 'Auth_LOADING';
export const Auth_ERROR = 'Auth_ERROR';
export const Auth_DATA = 'Auth_DATA';

export const SIGN_OUT = 'SIGN_OUT';

